import { OptionDto } from "@/dtos";
import { DownloadVehicleCollectionType } from "@/helpers/types";

const downloadVehicleCollectionTypes = [
    { value: DownloadVehicleCollectionType.RABBITMQ, label: 'Rabbit MQ' },
] as OptionDto[];

export const getDownloadVehicleCollectionTypeOptions = (): OptionDto[] => {
    return downloadVehicleCollectionTypes;
}

export const getDownloadVehicleCollectionTypeOption = (value?: number): OptionDto => {
    return downloadVehicleCollectionTypes.find((x) => x.value == value) ?? downloadVehicleCollectionTypes[0];
}

export const getDownloadVehicleCollectionTypeLabel = (value: number): string => {
    return downloadVehicleCollectionTypes.find((x) => x.value == value)?.label ?? downloadVehicleCollectionTypes[0].label;
}